/**
 * @generated SignedSource<<380c07f18de73e99f15b6146576e954b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useShouldPresentBookingAsLockedRequest_booking$data = {
  readonly request?: {
    readonly bookingRule: {
      readonly __typename: string;
      readonly id: string;
      readonly requestConfig?: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly startSlot: {
    readonly agenda: {
      readonly configuredRequestRestrictions: {
        readonly edges: ReadonlyArray<{
          readonly liftAt: string | null | undefined;
          readonly node: {
            readonly __typename: string;
            readonly id: string;
            readonly requestConfig?: {
              readonly id: string;
            } | null | undefined;
          } | null | undefined;
          readonly requestCloses: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    };
  } | null | undefined;
  readonly " $fragmentType": "useShouldPresentBookingAsLockedRequest_booking";
};
export type useShouldPresentBookingAsLockedRequest_booking$key = {
  readonly " $data"?: useShouldPresentBookingAsLockedRequest_booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShouldPresentBookingAsLockedRequest_booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RequestConfig",
        "kind": "LinkedField",
        "name": "requestConfig",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RequestRule",
    "abstractKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Request",
    "kind": "LinkedField",
    "name": "request",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "bookingRule",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useShouldPresentBookingAsLockedRequest_booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": "configuredRequestRestrictions",
              "args": [
                {
                  "kind": "Literal",
                  "name": "type",
                  "value": [
                    "REQUEST"
                  ]
                }
              ],
              "concreteType": "AgendaBookingRulesConnection",
              "kind": "LinkedField",
              "name": "requestWindowBookingRules",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AgendaBookingRulesEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "liftAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "requestCloses",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": (v1/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "requestWindowBookingRules(type:[\"REQUEST\"])"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v2/*: any*/),
      "type": "StandardBooking",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v2/*: any*/),
      "type": "LessonBooking",
      "abstractKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "dfe5a37132e0ed1fa4fc40225a730996";

export default node;
